import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/layout/navbar";
import HeroSection from "@/components/hero-section";
import SocialProofSection from "@/components/social-proof-section";
import FeaturesSection from "@/components/features-section";
import CalculatorSection from "@/components/calculator-section";
import CtaSection from "@/components/cta-section";
import Footer from "@/components/layout/footer";
import PerformanceMonitor from "@/components/PerformanceMonitor";
import HomeSEO from "@/components/HomeSEO";

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleGetStartedClick = () => {
    navigate("/pa/sign-up");
  };

  const handleWatchDemoClick = () => {
    navigate("/demo");
  };

  return (
    <div className="min-h-screen bg-slate-900">
      <HomeSEO />
      <PerformanceMonitor />
      <Navbar />
      <HeroSection onGetStartedClick={handleGetStartedClick} onWatchDemoClick={handleWatchDemoClick} />
      <SocialProofSection />
      <FeaturesSection />
      <CalculatorSection />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default HomePage;
